import { isValidExtension, isLowerThanMib } from '@/utils';
import { supportedExtensions as defaultExtensions } from '@/constants/supportedExtensions';

export type ValidationObject = {
  valid: boolean;
  errorMsg: string;
  value?: number;
};

export type ValidateFnData = {
  type: string;
  size: number;
  maxFileSize: number;
  supportedExtensions: string;
};

export type ValidateFnConfiguration = {
  maxFileSize?: number;
  supportedExtensions?: string;
};

export const validateFn = ({
  type: fileType,
  size: fileSize,
  maxFileSize,
  supportedExtensions,
}: ValidateFnData): {
  type: ValidationObject;
  size: ValidationObject;
} => {
  const isLowerThan = isLowerThanMib(maxFileSize);
  const hasValidExtension = isValidExtension(
    supportedExtensions || defaultExtensions
  );

  return {
    type: {
      valid: hasValidExtension(fileType),
      errorMsg: `invalid-file-type`,
    },
    size: {
      valid: isLowerThan(fileSize),
      errorMsg: `invalid-file-size`,
      value: maxFileSize,
    },
  };
};

export const customValidateFn = (configuration: ValidateFnConfiguration) => {
  return (validateFnData: ValidateFnData): any => {
    return validateFn({ ...validateFnData, ...configuration });
  };
};
